<ng-container *ngIf="!isTextArea && !maxDigits" [formGroup]="formParent">
    <div class="input-group" [ngClass]="{'has-error': control?.dirty && control?.invalid}">
        <label [ngClass]="class_label" [for]="frmControl" class="class_label">{{ label }}</label>
        <input            
            [type]="type"
            [id]="frmControl"
            [formControlName]="frmControl"
            [placeholder]="placeholder"
            (blur)="focusOutInput()"
            (focus)="focusInput()"
            (keyup)="keyupInput($event)"
            autocomplete="off"
            [readonly]="isReadOnly"
            [ngClass]="{'input-error': control?.dirty && control?.invalid}"
        />        
    </div>
</ng-container>
<ng-container *ngIf="!isTextArea && maxDigits" [formGroup]="formParent">
    <div class="input-group" [ngClass]="{'has-error': control?.dirty && control?.invalid}">
        <label [for]="frmControl">{{ label }}</label>
        <input            
            [type]="type"
            [id]="frmControl"
            [formControlName]="frmControl"
            [placeholder]="placeholder"
            (blur)="focusOutInput()"
            (focus)="focusInput()"
            (keyup)="keyupInput($event)"
            autocomplete="off"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            [maxlength]="maxDigits"
            [readonly]="isReadOnly"
            [ngClass]="{'input-error': control?.dirty && control?.invalid}"
        />        
    </div>
</ng-container>
<ng-container *ngIf="isTextArea" [formGroup]="formParent">
    <div class="input-group" [ngClass]="{'has-error': control?.dirty && control?.invalid}">
        <label [for]="frmControl">{{ label }}</label>
        <textarea            
            [id]="frmControl"
            [formControlName]="frmControl"
            [placeholder]="placeholder"
            (blur)="focusOutInput()"
            (focus)="focusInput()"
            (keyup)="keyupInput($event)"
            [readonly]="isReadOnly"
            [ngClass]="{'input-error': control?.dirty && control?.invalid}"
        ></textarea>        
    </div>
</ng-container>

<ng-container *ngIf="control?.dirty && control?.invalid">
    <span class="help-block" *ngFor="let errorMessage of control['errorMessages']"> {{errorMessage}} </span>
    <span class="help-block" *ngIf="control.errors.async"> {{control.errors.async}} </span>
</ng-container>
